import { MenuPoint } from '@agilox/ui-common';
import { selfTestMenuPoints } from './menupoints';

export const mobileMenupoints: MenuPoint[] = [selfTestMenuPoints.tests, selfTestMenuPoints.logout];
